import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const hasOnlySpaces = (value: string): boolean => value.trim().length === 0;

const disallowedTagLikeRe = /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9]*\b[^>]*>/;
const disallowedAngleBracketsRe = /[<>]/;



export const testimonialNameValidator = (): ValidatorFn => {
  const allowedRe = /^[A-Za-z ]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || String(raw) === '') return null;

    const str = String(raw);

    if (hasOnlySpaces(str)) return { required: true };

    const trimmed = str.trim();

    if (trimmed.length < 2) {
      return { testimonialNameMinLength: { requiredLength: 2, actualLength: trimmed.length } };
    }
    if (trimmed.length > 50) {
      return { testimonialNameMaxLength: { requiredLength: 50, actualLength: trimmed.length } };
    }

    // No leading/trailing spaces allowed by rule; we provide a dedicated error too.
    if (str !== trimmed) return { trim: true };

    if (!allowedRe.test(trimmed)) return { testimonialNameAllowedChars: true };

    return null;
  };
};

export const testimonialTextValidator = (): ValidatorFn => {
  const allowedRe = /^[A-Za-z0-9 .,:!\?;\(\)\-\/&\'"]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || String(raw) === '') return null;

    const str = String(raw);

    if (hasOnlySpaces(str)) return { required: true };

    const trimmed = str.trim();

    if (str !== trimmed) return { trim: true };

    if (trimmed.length < 2) {
      return { testimonialMinLength: { requiredLength: 2, actualLength: trimmed.length } };
    }
    if (trimmed.length > 500) {
      return { testimonialMaxLength: { requiredLength: 500, actualLength: trimmed.length } };
    }

    if (!allowedRe.test(trimmed)) return { testimonialAllowedChars: true };

    return null;
  };
};

export const commentTextValidator = (): ValidatorFn => {
  // Same allowed chars as testimonial text.
  const allowedRe = /^[A-Za-z0-9 .,:!\?;\(\)\-\/&\'"]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || String(raw) === '') return null;

    const str = String(raw);

    if (hasOnlySpaces(str)) return { required: true };

    const trimmed = str.trim();

    if (str !== trimmed) return { trim: true };

    if (trimmed.length < 2) {
      return { commentMinLength: { requiredLength: 2, actualLength: trimmed.length } };
    }
    if (trimmed.length > 500) {
      return { commentMaxLength: { requiredLength: 500, actualLength: trimmed.length } };
    }

    if (!allowedRe.test(trimmed)) return { commentAllowedChars: true };

    return null;
  };
};

export const reviewTextValidator = (): ValidatorFn => {
  const allowedRe = /^[A-Za-z0-9 .,:!\?;\(\)\-\/&\'" ]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || String(raw) === '') return null;

    const str = String(raw);

    if (hasOnlySpaces(str)) return { required: true };

    const trimmed = str.trim();

    if (str !== trimmed) return { trim: true };

    if (trimmed.length < 2) {
      return { reviewMinLength: { requiredLength:2, actualLength: trimmed.length } };
    }
    if (trimmed.length > 1000) {
      return { reviewMaxLength: { requiredLength: 1000, actualLength: trimmed.length } };
    }

    if (!allowedRe.test(trimmed)) return { reviewAllowedChars: true };

    // Prevent basic HTML/JS tag injection.
    if (disallowedAngleBracketsRe.test(trimmed) || disallowedTagLikeRe.test(trimmed)) {
      return { invalidHtml: true };
    }

    return null;
  };
};

